import React, { useEffect, useState } from "react";
import "./calenderView.css";
import { Typography, Modal, Box, CircularProgress } from "@mui/material";
import apiClient from "../../../services/apiClient";

const CalendarTable = ({ language }) => {
  const allMonths = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();
  const currentDay = new Date().getDate();

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedSection, setSelectedSection] = useState("Promotion");
  const sections = [
    "Promotion",
    "Transfer",
    "Training",
    "Probation",
    "Deputation",
    "Departmental Enquiry",
    "Seniority",
    "Compassionate appointment"
  ];
  const fixedSubsection = "Important Dates for Promotion";

  const [mockData, setMockData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchContentData = async ({ subsection, filter, language, section }) => {
    try {
      const response = await apiClient.post(`/section_page/view_subsection/`, {
        subsection,
        section,
        language,
        filter: {
          ...filter,
          section_filter: section,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error in fetchContentData:", error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const params = {
        language,
        section: selectedSection,
        subsection: fixedSubsection,
        filter: { year: selectedYear },
      };
      try {
        const data = await fetchContentData(params);
        setMockData(processData(data));
      } catch (error) {
        console.error("Error fetching calendar data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [selectedSection, language, selectedYear]);

  const processData = (responseData) => {
    const result = {};
    const items = responseData.data ? responseData.data : responseData;
    items.forEach((item) => {
      const key = `${item.year}-${item.month}-${item.date}`;
      result[key] = {
        id: item.id,
        title: item.title,
        description: item.description,
      };
    });
    return result;
  };

  const handleShowMore = async (id) => {
    try {
      const params = {
        language,
        section: selectedSection,
        subsection: fixedSubsection,
        filter: { id },
      };
      const response = await apiClient.post(`/section_page/get_calendar_info_byid/`, params);
      setPopupData(response.data);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching event details:", error);
    }
  };

  const handleYearChange = (event) => {
    setSelectedYear(parseInt(event.target.value, 10));
  };

  const handleSectionChange = (event) => {
    setSelectedSection(event.target.value);
  };

  const renderMonthEvents = (monthIndex) => {
    const monthName = allMonths[monthIndex];
    const monthEvents = Object.entries(mockData).filter(([key]) =>
      key.startsWith(`${selectedYear}-${monthName}-`)
    );

    if (monthEvents.length === 0) {
      return (
        <div className="no-events">
          <Typography variant="body2" color="textSecondary">
            No events
          </Typography>
        </div>
      );
    }

    // Sort events by day
    monthEvents.sort((a, b) => {
      const dayA = parseInt(a[0].split("-")[2], 10);
      const dayB = parseInt(b[0].split("-")[2], 10);
      return dayA - dayB;
    });

    // Array of background colors for events
    const eventColors = [
      "#BBDEFB", // blue
      "#B3E5FC", // light blue
      "#B2EBF2", // cyan
      "#B2DFDB", // teal
    ];

    return (
      <div className="month-events-list">
        {monthEvents.map(([key, event], idx) => {
          const day = key.split("-")[2];
          const isCurrentDay =
            parseInt(day, 10) === currentDay &&
            monthIndex === currentMonthIndex &&
            selectedYear === currentYear;
          return (
            <div
              key={key}
              className={`calendar-day event-cell ${isCurrentDay ? "current-day" : ""}`}
              onClick={() => handleShowMore(event.id)}
              style={{
                backgroundColor: eventColors[idx % eventColors.length],
                padding: "5px",
                margin: "3px 0",
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              <div className="day-number">{day}</div>
              <div className="event-title">{event.title}</div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="calendar-container">
      {/* Dropdown Controls */}
      <div className="controls">
        <div className="year-selector">
          <span>Year: </span>
          <select value={selectedYear} onChange={handleYearChange}>
            {Array.from({ length: 10 }).map((_, index) => {
              const year = currentYear - 5 + index;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </select>
        </div>
        <div className="section-selector">
          <span>Section: </span>
          <select value={selectedSection} onChange={handleSectionChange}>
            {sections.map((sec) => (
              <option key={sec} value={sec}>
                {sec}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Calendar Grid */}
      {isLoading ? (
        <div className="loading-spinner">
          <CircularProgress />
        </div>
      ) : (
        <div className="year-calendar-grid">
          {allMonths.map((month, index) => (
            <div key={index} className="month-box">
              <div className="month-name">{month}</div>
              {renderMonthEvents(index)}
            </div>
          ))}
        </div>
      )}

      {/* Modal for Event Details */}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box className="modal-box">
          <button className="close-button" onClick={() => setIsModalOpen(false)}>
            ×
          </button>
          <h2>{popupData?.title}</h2>
          <p>{popupData?.description}</p>
        </Box>
      </Modal>
    </div>
  );
};

export default CalendarTable;
